// extracted by mini-css-extract-plugin
export default {"input":"Search_input__f6TM0","icon":"Search_icon__LBvC9","root":"Search_root__gUwnb","closeBtn":"Search_closeBtn__Yk6RA"};